/**
 * Мост «открыть экран входа». Единая модалка авторизации живёт в `App`, а
 * попросить её открыть нужно из мест, куда `openLoginModal` пропсами не
 * доходит (общий хук покупки: карточки /balance, пейвол, модалка пополнения).
 * Устроен как `topUpModalBridge`: `App` регистрирует opener, остальные зовут
 * `requestOpenAuthModal()`.
 */
let opener = null;
export function registerAuthModalOpener(fn) {
    opener = fn;
}
/** Открыть экран входа. `false` — открыть некому (opener не зарегистрирован). */
export function requestOpenAuthModal() {
    if (!opener)
        return false;
    try {
        opener();
        return true;
    }
    catch (e) {
        console.error("requestOpenAuthModal", e);
        return false;
    }
}
